// Kayıt ve ödemeleri açmak/kapatmak için bu değerleri değiştirin.
export const SIGNUP_OPEN = true;
export const PAYMENT_OPEN = true;
export const PROFILE_EDIT_OPEN = true;
// Yarışma Kurulu kararıyla feragat sistemi kapalı. Açılırsa ilgili bölüme FERAGAT butonu da eklenmeli.
export const DISCLAIM_OPEN = false;

// Yeni sezonun başlangıcı. "Bilgilerim güncel" onayını bu tarihten önce vermiş
// (ya da hiç vermemiş) öğrenci ve öğretmenlere onay ekranı gösterilir.
export const SEASON_START = new Date("2026-09-24T00:00:00+03:00");

// Erken kayıt fiyatı bu tarihe kadar geçerli, sonrasında LATE_PRICE uygulanır.
export const EARLY_PRICE = 450;
export const LATE_PRICE = 550;
export const EARLY_PRICE_DEADLINE = new Date("2026-12-31T23:59:59+03:00");
export const PRICE_TEXT =
  "31.12.2026 saat 23.59'a kadar KDV dahil 450 TL, bu tarihten sonra KDV dahil 550 TL";
export const currentPrice = () =>
  new Date() <= EARLY_PRICE_DEADLINE ? EARLY_PRICE : LATE_PRICE;
